var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72042 11.9996C4.23478 12.5889 5.231 13.6524 6.53296 14.6716C8.28453 16.0428 10.4827 17.2496 12.7426 17.2496C15.0025 17.2496 17.2007 16.0428 18.9523 14.6716C20.2542 13.6524 21.2504 12.5889 21.7648 11.9996C21.2504 11.4103 20.2542 10.3468 18.9523 9.32754C17.2007 7.95631 15.0025 6.74957 12.7426 6.74957C10.4827 6.74957 8.28453 7.95631 6.53296 9.32754C5.231 10.3468 4.23478 11.4103 3.72042 11.9996ZM5.60831 8.14643C7.45267 6.70256 9.98078 5.24957 12.7426 5.24957C15.5044 5.24957 18.0325 6.70256 19.8769 8.14643C21.7381 9.6035 23.0118 11.1374 23.2797 11.4701C23.5296 11.7804 23.5296 12.2188 23.2797 12.529C23.0118 12.8618 21.7381 14.3956 19.8769 15.8527C18.0325 17.2966 15.5044 18.7496 12.7426 18.7496C9.98078 18.7496 7.45268 17.2966 5.60831 15.8527C3.74709 14.3956 2.47342 12.8618 2.20546 12.529C1.95561 12.2188 1.9556 11.7804 2.20546 11.4701C2.47342 11.1374 3.74708 9.60351 5.60831 8.14643Z",
    fill: "#F5F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7426 9.74957C11.5 9.74957 10.4926 10.7569 10.4926 11.9996C10.4926 13.2422 11.5 14.2496 12.7426 14.2496C13.9852 14.2496 14.9926 13.2422 14.9926 11.9996C14.9926 10.7569 13.9852 9.74957 12.7426 9.74957ZM8.99261 11.9996C8.99261 9.9285 10.6715 8.24957 12.7426 8.24957C14.8137 8.24957 16.4926 9.9285 16.4926 11.9996C16.4926 14.0706 14.8137 15.7496 12.7426 15.7496C10.6715 15.7496 8.99261 14.0706 8.99261 11.9996Z",
    fill: "#F5F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/IconEye.325447ab30c8d0467b31fc540afca3b7.svg";
export { ForwardRef as ReactComponent };